import React from 'react';
import { DatePicker } from 'antd';
import FormItem from '../FormItem/FormItem';

const { RangePicker } = DatePicker;

const DatePickerField = ({
  label,
  name,
  options,
  colon = false,
  form,
  inputProps,
  ...props
}) => {
  const { getFieldDecorator } = form;

  return (
    <FormItem {...props} colon={colon} label={label}>
      {getFieldDecorator(name, options)(<RangePicker {...inputProps} />)}
    </FormItem>
  );
};

export default DatePickerField;
